import axiosProxy from '@/api/setting';

export function getImageUploadAuth(data) {
  return axiosProxy({
    url: '/app/users/me/avatar/authorize',
    method: 'post',
    data,
  });
}
export function uploadImages(url, formData) {
  return axiosProxy({
    TOKEN: false,
    baseURL: url,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  });
}